import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ensureInboxCustomer from '../../../../services/inbox/ensureInboxCustomerService';

/**
 * @param {import('../../../utils/conversationUtils').SerializedConversation | null} conversation
 */
export default function useEnsureInboxCustomer(conversation) {
  const dispatch = useDispatch();
  const [isEnsuring, setIsEnsuring] = useState(false);

  const run = useCallback(async () => {
    if (!conversation?.id) {
      return { success: false, error: 'No conversation' };
    }
    setIsEnsuring(true);
    try {
      return await dispatch(ensureInboxCustomer(conversation));
    } finally {
      setIsEnsuring(false);
    }
  }, [conversation, dispatch]);

  return { ensureInboxCustomer: run, isEnsuring };
}
